module.exports = __webpack_public_path__ + "img/support.31938fb.svg";